import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { FC, ReactNode } from "react";
import Typography from "../Typography";

type ComparisonCalloutProps = {
  body: ReactNode;
};

// Honest "this is what we don't do" block. Used on pages 03, 08, 14,
// 16 to disambiguate from competitors with different intent
// (text-to-video, URL trim, audio-only podcasts). Soft callout — no
// border, just a tinted background — to read as an editorial aside
// rather than a warning.
const ComparisonCallout: FC<ComparisonCalloutProps> = ({ body }) => {
  return (
    <section className="max-w-3xl mx-auto px-3 md:px-12 mt-12 mb-16">
      <div className="rounded-2xl bg-violet-50 px-6 py-5 flex gap-3 items-start">
        <InformationCircleIcon
          className="w-5 h-5 shrink-0 text-violet-500 mt-0.5"
          aria-hidden="true"
        />
        <Typography variant="body2" className="text-slate-700 leading-relaxed">
          {body}
        </Typography>
      </div>
    </section>
  );
};

export default ComparisonCallout;
